import { Input, DropDown } from '.'
import { useContext, useEffect, useState } from "react"
import { DataContext } from "../data/DataContext"
import { lstTypeDocument, catRelationship } from '../data/MochaData'

const BeneficiaryCtrl = (data: IBeneficiary) => {
    const [benef, setBeneficiary] = useState(data);
    const { vidaCR, setVidaCR, changeHandler, changeHandler2 } = useContext(DataContext);
   
    const changeInputFormat = (prop: string, value: any) => setBeneficiary({ ...benef, [prop]: value })
    const change = (e: any) => setBeneficiary({ ...benef, [e.target.name]: e.target.value }) 

    useEffect(() => {
        let lst = vidaCR.lstBeneficiary;
        if(lst !==  undefined && lst.length > 0)
        {
            let index = lst.findIndex( x => x.id === benef.id)
            if(index !== undefined)
            {
                lst[index].identification = benef.identification
                lst[index].typeDocument = benef.typeDocument
                lst[index].name1 = benef.name1
                lst[index].name2 = benef.name2
                lst[index].lastname1 = benef.lastname1
                lst[index].lastname2 = benef.lastname2
                lst[index].percentage = benef.percentage
                lst[index].relationship = benef.relationship
                setVidaCR({...vidaCR, lstBeneficiary: lst})
            }
        }
    }, [benef])

    return <>
        {data.id === 2 && <>
            <div className='mt-30 lbl-input-vida-cr' style={{fontSize: '18px'}}>
                <span>Datos del segundo beneficiario</span>
            </div>
        </>}
        <Input
            id={`name1_${benef.id}`}
            field="name1"
            label="Nombres"
            onChange={change}
            value={benef.name1}
        />
        <Input
            id={`name2_${benef.id}`}
            field="name2"
            label=""
            onChange={change}
            value={benef.name2}
            onlyInput
            isRequired={false}
        />
        <Input
            id={`lastname1_${benef.id}`}
            field="lastname1"
            label="Apellidos"
            onChange={change}
            value={benef.lastname1}
        />
        <Input
            id={`lastname2_${benef.id}`}
            field="lastname2"
            label="Nombres"
            onChange={change}
            value={benef.lastname2}
            onlyInput
            isRequired={false}
        />
        <DropDown
            id={`typeDocument_${benef.id}`}
            label="Tipo de identificación"
            field="typeDocument"
            valueSelect={benef.typeDocument}
            dataProvider={lstTypeDocument}
            onChangeSelect={changeInputFormat}
            readonly
        />
        {benef.typeDocument === '1' &&
            <Input
                id={`identification_${benef.id}`}
                label="Número de identificación"
                value={benef.identification}
                field="identification"
                onChange={change}
                type="mask"
                mask="9-9999-9999"
                pattern="\d-\d\d\d\d-\d\d\d\d"
                title="Documento invalido"
            />
        }
        {benef.typeDocument !== '1' &&
            < Input

                id={`identification_${benef.id}`}
                label='Número de identificación'
                value={benef.identification}
                field='identification'
                onChange={change}
            />
        }
        <DropDown
            id={`relationship_${benef.id}`}
            label="Parentesco"
            field="relationship"
            valueSelect={benef.relationship}
            dataProvider={catRelationship}
            onChangeSelect={changeInputFormat}
        />
        < Input
            id={`percentage_${benef.id}`}
            label='% de Beneficio'
            value={benef.percentage}
            field='percentage'
            onChange={changeInputFormat}
            type='PERCENTAGE'
        />
    </>
}

export {
    BeneficiaryCtrl
}